import { FC, PropsWithChildren, useMemo } from "react";
import { useRouter } from "next/router";
import Page, { PageProps } from "components/Layout/Page";
import { useUpdatePtbSoundSetting } from "hooks/useUpdatePtbSoundSetting";

enum TabIndex {
  PTB,
  YOLO,
  RAFFLES,
  RAFFLE,
}

export const WinPageLayout: FC<PropsWithChildren<PageProps>> = ({ children, ...props }) => {
  const router = useRouter();

  // Patch to save PTB sound setting
  useUpdatePtbSoundSetting();

  const hideFooter = useMemo(() => {
    if (router.pathname.includes("/yolo")) {
      return TabIndex.YOLO;
    }

    if (router.pathname.includes("/poke-the-bear")) {
      return TabIndex.PTB;
    }

    return TabIndex.YOLO;
  }, [router.pathname]);

  return (
    <Page hideFooter={[TabIndex.YOLO, TabIndex.PTB].includes(hideFooter)} {...props}>
      {children}
    </Page>
  );
};
